<template>
  <div class="home">
    <el-container>
      <el-header>
        <div class="haderMain">
          <div class="logo">
            <span class="title">浙江久功环境科技有限公司</span>
            <!-- <img src="@/assets/imgs/logo.png" style="width: 200px" /> -->
          </div>
          <div class="nav">
            <el-button type="text" style="color: #fff">首页</el-button>
            <el-button type="text" style="color: #fff">关于公司</el-button>
            <el-button type="text" style="color: #fff">项目案例</el-button>
            <el-button type="text" style="color: #fff">企业动态</el-button>
            <el-button type="text" style="color: #fff">视频专区</el-button>
            <el-button type="text" style="color: #fff">联系我们</el-button>
          </div>
        </div>
      </el-header>
      <el-main>
        <div class="rotationMap">
          <el-carousel :interval="5000" arrow="never" :autoplay="true">
            <el-carousel-item>
              <div class="rotationMap1">
                <div class="rotationMapMain">
                  <div class="textContent">主攻<br />数据价值开放</div>
                  <el-button type="text" style="color: #fff"
                    >了解详情</el-button
                  >
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="rotationMap2">
                <div class="rotationMapMain">
                  <div class="textContent">主攻<br />数据价值开放</div>
                  <el-button type="text" style="color: #fff"
                    >了解详情</el-button
                  >
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="rotationMap3">
                <div class="rotationMapMain">
                  <div class="textContent">主攻<br />数据价值开放</div>
                  <el-button type="text" style="color: #fff"
                    >了解详情</el-button
                  >
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="aboutCompany">
          <div class="statistics">
            <div>
              <h3>5年</h3>
              <h4>行业沉淀</h4>
            </div>
            <div>
              <h3>30+人</h3>
              <h4>技术团队</h4>
            </div>
            <div>
              <h3>2018年</h3>
              <h4>公司成立</h4>
            </div>
            <div>
              <h3>500平</h3>
              <h4>办公场所</h4>
            </div>
          </div>
          <el-divider content-position="left">
            关于公司 About Company
          </el-divider>
          <div class="briefIntroduction">
            <div class="briefIntroductionLeft">
              <img
                src="@/assets/imgs/aboutCompany.jpg"
                style="width: 600px; height: 300px"
              />
            </div>
            <div class="briefIntroductionRight">
              <span class="companyText"
                >&nbsp;&nbsp;浙江久功环境科技有限公司成立于2018年底，是一家研究数据安全流
                转场景和落地的公司。</span
              >
              <div class="companyBtn">
                <el-button color="#F8811F" style="color: #fff">
                  企业简介
                </el-button>
                <el-button color="#F8811F" style="color: #fff">
                  企业文化
                </el-button>
                <el-button color="#F8811F" style="color: #fff">
                  时代背景
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="applicationCase">
          <el-divider content-position="left">
            应用案例 PROJECT CASES
          </el-divider>
          <div class="applicationCaseRotationMap">
            <el-carousel :interval="5000" type="card" :autoplay="false">
              <el-carousel-item>
                <div class="applicationCase1">
                  <div class="applicationCaseMain">
                    <el-row>
                      <el-col :span="17">浙江省生活垃圾分类监管平台</el-col>
                      <el-col :span="7">2021-02-14</el-col>
                    </el-row>
                    <el-row> 浙江 </el-row>
                  </div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="applicationCase2">
                  <div class="applicationCaseMain">
                    <el-row>
                      <el-col :span="17">区县垃圾分类监管平台</el-col>
                      <el-col :span="7">2021-03-14</el-col>
                    </el-row>
                    <el-row> 浙江 </el-row>
                  </div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="applicationCase3">
                  <div class="applicationCaseMain">
                    <el-row>
                      <el-col :span="17">区县智慧环卫平台</el-col>
                      <el-col :span="7">2021-04-14</el-col>
                    </el-row>
                    <el-row> 浙江 </el-row>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="coreTechnology">
          <el-divider content-position="left">
            核心技术 core technology
          </el-divider>
          <div class="coreTechnologyRotationMap">
            <div class="technology">
              <img
                src="@/assets/imgs/technology.png"
                style="width: 350px; height: 200px"
              />
              <div class="technologyInfo">
                <div>以数据目录为开放原则</div>
                <span> 2020-06-04 </span>
                <span>
                  以《数据安全法》国家标准为基准，参照浙江省《公共数据分类分级指南》，建设相
                  应的数据开放接口，提供数据开放能力。
                </span>
              </div>
            </div>
            <div class="technology">
              <img
                src="@/assets/imgs/technology.png"
                style="width: 350px; height: 200px"
              />
              <div class="technologyInfo">
                <div>以隐私计算为计算技术</div>
                <span> 2020-06-04 </span>
                <span>
                  依托隐私计算能力，实现隐私数据的可用而不可见，进而实现公共数据与社会数据的
                  安全流转。
                </span>
              </div>
            </div>
            <div class="technology">
              <img
                src="@/assets/imgs/technology.png"
                style="width: 350px; height: 200px"
              />
              <div class="technologyInfo">
                <div>以区块链技术为管理技术</div>
                <span> 2020-06-04 </span>
                <span>
                  依托区块链的“智能合约”功能，替代传统的审批约定、行为约定、数据约定，保证数
                  据行为的存证、可溯源、不可篡改。
                </span>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer>
        <div class="footInfo">
          <div class="info">
            <div style="text-align: left">
              <!-- <img src="@/assets/imgs/logo.png" style="width: 189px" /> -->
              <span class="title">浙江久功环境科技有限公司</span>
              <div class="companyInfo">
                地址：浙江省杭州市莫干山路1418-66号4幢7层707室（上城科技工业基地）
              </div>
              <!-- <div class="companyInfo">邮编：310000</div>
              <div class="companyInfo">电话：0571-65218885</div> -->
            </div>
          </div>
          <div class="relatedLinks">
            <el-row :gutter="70">
              <el-col :span="6">
                <div>加入我们</div>
                <span>社会招聘</span>
                <span>校园招聘</span>
              </el-col>
              <el-col :span="6">
                <div>关于我们</div>
                <span>公司简介</span>
                <span>业务范围</span>
                <span>成长轨迹</span>
                <span>企业精神</span>
              </el-col>
              <el-col :span="6">
                <div>技术咨询</div>
                <span>资料下载</span>
                <span>软件下载</span>
                <span>常见问题</span>
                <span>技术支持</span>
              </el-col>
              <el-col :span="6">
                <div>法律信息</div>
                <span>服务协议</span>
                <span>隐私政策</span>
                <span>知识产权</span>
              </el-col>
            </el-row>
          </div>
          <!-- <div class="qrCode">
            <div>
              <img
                src="@/assets/imgs/qrCode.png"
                style="width: 110px; height: 110px"
              />
              <span>扫码关注官方微信</span>
            </div>
            <div>
              <img
                src="@/assets/imgs/qrCode.png"
                style="width: 110px; height: 110px"
              />
              <span>扫码关注官方微博</span>
            </div>
          </div> -->
        </div>
        <div class="safeLink">
          <a href="https://beian.miit.gov.cn/">浙ICP备2021007192号-1</a>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script setups></script>
<style lang="less">
body {
  margin: 0;
  .home {
    .el-header {
      z-index: 100;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100px;
      background: rgba(0, 0, 0, 0.42);
      position: fixed;
      .haderMain {
        z-index: 101;
        display: flex;
        top: 0;
        left: 0;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        width: 1200px;
        margin: 0 auto;
        .nav {
          .el-button {
            margin-right: 50px;
            font-size: 16px;
          }
          .el-button:hover {
            border-bottom: 2px solid #f8811f;
          }
          .el-button:hover > span {
            color: #f8811f;
          }
          .el-button:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .el-main {
      padding: 0;
      .rotationMap {
        height: 700px;
        .el-carousel {
          height: 100%;
          .el-carousel__arrow--left {
            width: 24px;
            background-color: inherit;
            height: 40px;
            left: 310px;
          }
          .el-carousel__arrow--right {
            width: 24px;
            background-color: inherit;
            height: 40px;
            right: 310px;
          }
          .el-carousel__container {
            height: 100%;
          }
          .el-carousel__indicators--horizontal {
            left: 10%;
            .el-carousel__button {
              width: 50px;
              height: 10px;
              border-radius: 4px;
            }
          }
        }
        .rotationMap1,
        .rotationMap2,
        .rotationMap3 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 100%;
          height: 100%;
          background-image: url(@/assets/imgs/rotationMap.jpg);
          background-size: cover;
          .rotationMapMain {
            width: 1200px;
            margin: 0 auto;
            .textContent {
              height: 129px;
              font-size: 48px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #ffffff;
              margin-bottom: 80px;
            }
            .el-button {
              width: 250px;
              height: 50px;
              border: 1px solid #ffffff;
              border-radius: 10px;
            }
          }
        }
      }
      .aboutCompany {
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;
        height: 640px;
        background: #f2f2f2;
        .statistics {
          position: absolute;
          top: -70px;
          left: 50%;
          transform: translate(-50%, 0);
          width: 1200px;
          height: 135px;
          background: #ffffff;
          border-radius: 10px;
          box-shadow: 0px 0px 106px 0px rgba(0, 0, 0, 0.25);
          color: #f8811f;
          display: flex;
          align-items: center;
          div {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            h3 {
              margin: 0;
              font-size: 36px;
              font-family: Source Han Sans CN, Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              color: #f8811f;
              letter-spacing: 1.8px;
            }
            h4 {
              margin: 0;
              font-size: 18px;
              font-family: Source Han Sans CN, Source Han Sans CN-Medium;
              font-weight: 500;
              text-align: left;
              color: #f8811f;
              letter-spacing: 0.9px;
            }
          }
        }
        .el-divider {
          width: 1200px;
          margin-top: 180px;
          height: 2px;
          // opacity: 0.25;
          background: #f4d6bd;
          .el-divider__text {
            font-size: 36px !important;
            left: 140px;
            color: #f8811f;
            font-size: 18px;
            background-color: #f2f2f2;
          }
        }
        .briefIntroduction {
          width: 1200px;
          margin-top: 40px;
          height: 300px;
          display: flex;
          .briefIntroductionLeft {
            flex: 1;
            width: 600px;
            height: 300px;
            background: #f2f2f2;
            border-radius: 10px;
            overflow: hidden;
          }
          .briefIntroductionRight {
            flex: 1;
            padding-left: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            .companyText {
              font-size: 18px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: justifyLeft;
              color: #000;
              letter-spacing: 0.9px;
            }
            .companyBtn {
              .el-button {
                margin-right: 30px;
                width: 150px;
                height: 40px;
                background: #f8811f;
                border-radius: 10px;
                font-size: 18px;
                box-shadow: -5px 0px 27px 5px rgba(0, 0, 0, 0.2);
              }
            }
          }
        }
      }
      .applicationCase {
        display: flex;
        align-items: center;
        flex-direction: column;
        .el-divider {
          width: 1200px;
          margin-top: 80px;
          margin-bottom: 50px;
          height: 2px;
          // opacity: 0.25;
          background: #f4d6bd;
          .el-divider__text {
            font-size: 36px !important;
            left: 140px;
            color: #f8811f;
            font-size: 18px;
          }
        }
        .applicationCaseRotationMap {
          width: 1200px;
          .el-carousel {
            height: 100%;
            .el-carousel__container {
              height: 400px !important;
            }
            .applicationCase1,
            .applicationCase2,
            .applicationCase3 {
              height: 100%;
              background-image: url(@/assets/imgs/aboutCompany.jpg);
              background-size: cover;
              display: flex;
              flex-direction: column;
              border-radius: 10px;
              overflow: hidden;
              justify-content: flex-end;
              .applicationCaseMain {
                height: 160px;
                background-color: #f8811f;
                .el-row {
                  padding: 10px 50px;
                  color: #f2f2f2;
                  .el-col:first-child {
                    font-size: 24px;
                    font-weight: 500;
                  }
                }
              }
            }
          }
        }
      }
      .coreTechnology {
        display: flex;
        height: 700px;
        align-items: center;
        flex-direction: column;
        background: url(@/assets/imgs/technologyBg.jpg) no-repeat;
        background-size: 110% 100%;
        .el-divider {
          width: 1200px;
          margin-top: 80px;
          margin-bottom: 50px;
          height: 2px;
          // opacity: 0.25;
          background: #f4d6bd;
          .el-divider__text {
            font-size: 36px !important;
            left: 140px;
            color: #f8811f;
            font-size: 18px;
          }
        }
        .coreTechnologyRotationMap {
          width: 1200px;
          height: 500px;
          display: flex;
          .technology {
            flex: 1;
            margin-right: 75px;
            box-shadow: 1px 1px 7px -3px;
            .technologyInfo {
              height: 250px;
              background: #fff;
              display: flex;
              flex-direction: column;
              div {
                font-size: 18px;
                color: #010101;
                letter-spacing: 0.9px;
                margin: 22px 0 50px 34px;
              }
              span {
                opacity: 0.5;
                font-size: 14px;
                color: #010101;
                margin-left: 35px;
                margin-bottom: 20px;
              }
            }
          }
        }
      }
    }
    .el-footer {
      padding: 0;
      .footInfo {
        overflow: hidden;
        height: 300px;
        background: #353535;
        padding-top: 60px;
        display: flex;
        .info {
          flex: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          .companyInfo {
            font-size: 16px;
            color: #bababa;
            margin-top: 24px;
          }
        }
        .relatedLinks {
          flex: 3;
          .el-col {
            display: flex;
            flex-direction: column;
            div {
              font-size: 20px;
              color: #ffffff;
              margin-bottom: 42px;
            }
            span {
              font-size: 16px;
              color: #b2b2b2;
              margin-bottom: 23px;
            }
          }
        }
        .qrCode {
          flex: 1;
          display: flex;
          justify-content: center;
          div {
            display: flex;
            flex-direction: column;
            margin-right: 28px;
            span {
              font-size: 14px;
              color: #b2b2b2;
              margin-top: 10px;
            }
          }
        }
      }
      .safeLink {
        background: #353535;
        display: flex;
        justify-content: center;
        a {
          margin-bottom: 48px;
          color: #ffffff;
          text-decoration: none;
        }
      }
    }
  }
  .title {
    font-size: 25px;
    font-weight: 900;
    color: #eee;
  }
}
</style>
